<script lang="ts" setup>
import { CalendarX2 } from "lucide-vue-next";
import { useScriptTag } from "@vueuse/core";
import type { EventTypeGroup } from "../../App/EventTypes/types/EventTypeGroup";

const props = defineProps<{
    eventTypeGroup: EventTypeGroup;
    hasActiveEventTypes: boolean;
}>();

if (props.hasActiveEventTypes) {
    useScriptTag("https://iframe.zaptime.app/zaptime.js", () => {
        const zaptime = (
            window as typeof window & {
                Zaptime: (options: {
                    type: string;
                    config: { token: string };
                }) => { render: (selector: string) => void };
            }
        ).Zaptime;

        zaptime({
            type: "group",
            config: { token: props.eventTypeGroup.token },
        }).render("#zaptime-container");
    });
}
</script>

<template>
    <main class="bg-iron-50 px-4 py-16 sm:py-20 relative min-h-screen">
        <div
            v-if="hasActiveEventTypes"
            id="zaptime-container"
            class="max-w-5xl rounded-lg mx-auto"
        ></div>
        <section
            v-else
            class="max-w-xl rounded-2xl border-iron-200 bg-white px-6 shadow-sm mx-auto flex min-h-[520px] flex-col items-center justify-center border text-center"
        >
            <div
                class="h-16 w-16 bg-iron-100 flex items-center justify-center overflow-hidden rounded-full"
            >
                <img
                    v-if="eventTypeGroup.avatar"
                    :src="eventTypeGroup.avatar"
                    alt=""
                    class="h-full w-full object-cover"
                />
                <CalendarX2 v-else :size="25" class="text-iron-400" />
            </div>
            <p
                class="mt-5 text-xs font-semibold text-iron-400 tracking-[0.18em] uppercase"
            >
                {{ eventTypeGroup.title }}
            </p>
            <h1
                class="mt-3 text-2xl font-semibold tracking-tight text-iron-900"
            >
                {{ $t("my_page.public_empty.title") }}
            </h1>
            <p class="mt-3 max-w-md text-sm leading-6 text-iron-500">
                {{ $t("my_page.public_empty.description") }}
            </p>
        </section>
    </main>
</template>
